import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppNotification, PAYMENT_REQUEST_NOTIFICATION } from '../../core/models/notification';
import { NotificationStreamService } from '../../core/services/notification-stream-service';

@Component({
  selector: 'app-notification-bell',
  imports: [DatePipe],
  templateUrl: './notification-bell.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class NotificationBell implements OnInit, OnDestroy {
  protected notifications: AppNotification[] = [];
  protected isOpen = false;

  private subscription: Subscription | null = null;

  constructor(
    private readonly notificationStreamService: NotificationStreamService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.subscription = this.notificationStreamService.feed$.subscribe((notifications) => {
      this.notifications = notifications;
      this.cdr.detectChanges();
    });
    this.notificationStreamService.start();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  protected get unreadCount() {
    return this.notifications.filter((n) => !n.isRead).length;
  }

  protected toggle() {
    this.isOpen = !this.isOpen;
  }

  protected close() {
    this.isOpen = false;
  }

  /**
   * Opening a notification is the only thing that marks it read.
   *
   * Deliberately not done when the dropdown renders: a role broadcast is one shared document
   * on the server, so marking on render would mean whichever admin loaded the page first
   * silently emptied the queue for every other admin.
   */
  protected open(notification: AppNotification) {
    this.notificationStreamService.markAsRead(notification);
    this.close();

    if (notification.type === PAYMENT_REQUEST_NOTIFICATION && notification.referenceId) {
      this.router.navigate(['/payments', notification.referenceId]).then();
    }
  }

  protected dismiss(notification: AppNotification, event: Event) {
    // the row itself navigates; the dismiss button must not
    event.stopPropagation();
    this.notificationStreamService.delete(notification);
  }

  protected markAllAsRead() {
    for (const notification of this.notifications.filter((n) => !n.isRead)) {
      this.notificationStreamService.markAsRead(notification);
    }
  }
}
